module.exports = __webpack_public_path__ + "img/fullscreen.ee7718fd.svg";